import React from "react";
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router-dom";

import { mobile } from "../../themes/responsive";
import Toggler from "../navigation/Toggler";
import NavLinkList from "./NavLinkList";

const Navbar = ({
  theme,
  themeToggler,
  writeDiv,
  entriesDiv,
  handleWrite,
  handleEntries,
}) => {
  let navigate = useNavigate();
  let location = useLocation();

  return (
    <StyledNavbar>
      <Wrapper>
        <Left>
          {location.pathname === "/notes" ? (
            <Button
              onClick={() => {
                navigate("/");
              }}
            >
              home
            </Button>
          ) : (
            <Button
              onClick={() => {
                navigate("/notes");
              }}
            >
              notes
            </Button>
          )}
        </Left>

        <Center>
          {location.pathname === "/notes" ? (
            <Logo>
              <Link onClick={handleEntries} entriesDiv={entriesDiv}>
                archive
              </Link>
              .
              <Link onClick={handleWrite} writeDiv={writeDiv}>
                write
              </Link>
            </Logo>
          ) : (
            <Logo onClick={() => navigate("/")}>alan.waddell</Logo>
          )}
        </Center>

        <Right>
          <NavLinkList theme={theme} />
          <Toggler theme={theme} themeToggler={themeToggler} />
        </Right>
      </Wrapper>
    </StyledNavbar>
  );
};

export default Navbar;

const StyledNavbar = styled.nav`
  width: 100%;
  height: 60px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  transition: all 0.5s linear;
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const Button = styled.button`
  background-color: transparent;
  font-size: 1.3rem;
  border: none;
  &:hover {
    color: ${({ theme }) => theme.accent};
    cursor: pointer;
  }
  color: ${({ theme }) => theme.text};
  transition: all 0.4s linear;
  margin-right: 10px;

  ${mobile({ fontSize: "1rem" })};
`;

const Center = styled.div`
  flex: 6;
  text-align: center;
`;

const Logo = styled.div`
  font-weight: bold;
  font-size: 1.3rem;
  cursor: pointer;
  color: ${({ theme }) => theme.text};
  transition: all 0.4s linear;

  ${mobile({ fontSize: "1.2rem" })};
`;

const Link = styled.a`
  color: ${(props) => props.entriesDiv && "orange"};
  color: ${(props) => props.writeDiv && "orange"};

  &:hover {
    color: ${({ theme }) => theme.background};
  }
`;

const Right = styled.div`
  flex: 1;
  display: flex;
  ${mobile({ fontSize: "0.8rem" })};
`;
